
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const Journal = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");

  useEffect(() => {
    setPrevLocation(location?.state?.data || "Home");
  }, [location]);

  const articles = [
    {
      id: 1,
      title: "BigMart Fresh Launches!",
      description:
        "Discover our newly launched products this season. Fresh groceries, premium chocolates, and household essentials all under one roof.",
      image: "/assets/images/bigmart-launch.jpeg",
    },
    {
      id: 2,
      title: "Exclusive Offers This Month",
      description:
        "Enjoy amazing discounts and deals across categories. Don’t miss out on our limited-time offers!",
      image: "/assets/images/bigmart-offers.jpeg",
    },
    {
      id: 3,
      title: "Sustainable Shopping at BigMart",
      description:
        "Learn how we’re contributing to a greener future with eco-friendly packaging and sustainable products.",
      image: "/assets/images/bigmart-sustainable.jpeg",
    },
  ];

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="BigMart News & Updates" prevLocation={prevLocation} />

      <h1 className="text-3xl font-titleFont font-bold text-primeColor my-6">
        Latest Updates from BigMart
      </h1>
      <p className="text-gray-600 max-w-[700px] mb-10">
        Stay up-to-date with the latest news, launches, and promotions from
        BigMart. We bring you quality products, exclusive offers, and useful
        tips to make your shopping experience better.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {articles.map((article) => (
          <div
            key={article.id}
            className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
          >
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-semibold text-primeColor mb-2">
                {article.title}
              </h2>
              <p className="text-gray-700 text-sm">{article.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-12">
        <a
          href="https://wa.me/0542660433"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-primeColor text-white px-6 py-3 rounded-md font-semibold text-lg hover:bg-black hover:text-white transition duration-300"
        >
          Contact Us on WhatsApp
        </a>
      </div>
    </div>
  );
};

export default Journal;